// GENERATED by scripts/stamp-build.js at build time (npm `prebuild`). Do not edit.
//
// The value committed to the repo is a PLACEHOLDER and says so in `source`. Every build
// overwrites this file, so a bundle whose source is `placeholder` was never stamped and a
// bundle whose source is `unresolved` was stamped where no commit could be determined.
export const buildInfo = {
  "sha": "ea4bd6efdab00fc98d9b08d77f33638a22deb38a",
  "source": "cloudflare-pages",
  "builtAt": "2026-11-04T14:37:49.781Z"
};

export default buildInfo;
